<template>
  <div class="action-buttons">
    <button v-if="showPrev" @click="prevStep" class="action-left-button">{{ $t("buttons.prevStep") }}</button>
    <button v-if="showNext" @click="nextStep" class="action-right-button">{{ $t("buttons.nextStep") }}</button>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  name: "ActionButtons",
  props: { showPrev: { type: Boolean, default: true }, showNext: { type: Boolean, default: true }, showGenerate: Boolean },
  emits: ["prev-step", "next-step"],
  setup(props, { emit }) {
    const { t } = useI18n();
    const prevStep = () => emit("prev-step");
    const nextStep = () => emit("next-step");
    return { prevStep, nextStep, t };
  },
};
</script>

<style lang="scss" scoped>
.action-buttons {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    color: #000;
    text-align: center;
    font-size: 36px;
    font-weight: 600;
    border: none;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 30px;
    background: #ACF601;

    &.action-left-button { margin-left: 30px; padding-right: 10px; }
    &.action-right-button { margin-right: 30px; padding-left: 10px; }

    @media (max-width: 768px) {
      font-size: 18px;
      padding: 2px 4px;
    }

    @media (max-width: 435px) {
      font-size: 15px;
      padding: 2px 4px;
    }

    @media (max-width: 400px) {
      font-size: 12px;
      padding: 2px 4px;
    }

    @media (max-width: 368px) {
      font-size: 9px;
      padding: 2px 4px;
    }

    &:after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border-color: transparent;
      border-style: solid;
      border-width: 40px 40px 40px 0;

      @media (max-width: 768px) { border-width: 20px 20px 20px 0; }
    }

    &.action-left-button:after {
      right: 100%;
      border-right-color: #ACF601;
    }

    &.action-right-button:after {
      left: 100%;
      border-width: 40px 0 40px 40px;
      border-left-color: #ACF601;

      @media (max-width: 768px) { border-width: 20px 0 20px 20px; }
    }
  }
}
</style>